import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useRef, useState } from "react";
import Globe from "@dcl/icons/esm/nucleo/small/business-finance/globe";
import { GlobalHeader } from "../../index";
import { getClassNameFactory } from "../../../../utilities";
import { ElementStates } from "../../../../core/types/index";
var defaultLocale = "en-us";
export var LanguageSelector = function LanguageSelector(_ref) {
  var supportedLocales = _ref.supportedLocales,
      iconAltText = _ref.iconAltText,
      getLanguageName = _ref.getLanguageName,
      getCountryName = _ref.getCountryName,
      getCountryCode = _ref.getCountryCode,
      onSelectionChange = _ref.onSelectionChange,
      _ref$currentLocale = _ref.currentLocale,
      currentLocale = _ref$currentLocale === void 0 ? defaultLocale : _ref$currentLocale;
  var getClassName = getClassNameFactory(LanguageSelector.displayName);

  var _useState = useState(currentLocale),
      _useState2 = _slicedToArray(_useState, 2),
      selectedLocale = _useState2[0],
      setSelectedLocale = _useState2[1];

  var menuButtonRef = useRef();
  var rootElementRef = useRef(null);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      menuExpanded = _useState4[0],
      setMenuExpanded = _useState4[1];

  var getLanguageCode = function getLanguageCode(localeCode) {
    return localeCode.split("-")[0];
  };

  var formatItemLabel = function formatItemLabel(locale) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      lang: getLanguageCode(locale)
    }, "".concat(getLanguageName(locale), " "), /*#__PURE__*/React.createElement("abbr", {
      title: getCountryName(locale)
    }, "(", getCountryCode(locale), ")")));
  };

  var getListItem = function getListItem(locale) {
    var handleClick = function handleClick() {
      menuButtonRef.current.toggleMenuExpand();

      if (selectedLocale !== locale) {
        setSelectedLocale(locale);
        onSelectionChange(locale);
      }
    };

    var handleKeyDown = function handleKeyDown(e) {
      var downArrow = e.key === "ArrowDown";
      var upArrow = e.key === "ArrowUp";

      if ((downArrow || upArrow) && rootElementRef.current) {
        var currentIndex = supportedLocales.indexOf(locale);
        var targetIndex = downArrow ? currentIndex + 1 : currentIndex - 1;

        if (targetIndex >= 0 && targetIndex < supportedLocales.length) {
          var linkElements = rootElementRef.current.querySelectorAll("button[role=menuitem]");
          linkElements.item(targetIndex).focus();
        }
      } else if (e.key === "Escape") {
        menuButtonRef.current.toggleMenuExpand();
      }
    };

    var modifier = selectedLocale === locale ? ElementStates.SELECTED : "";
    return /*#__PURE__*/React.createElement(GlobalHeader.NavItem, {
      title: formatItemLabel(locale),
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      key: locale,
      modifier: modifier
    });
  };

  var menuButtonKeyDownHandler = function menuButtonKeyDownHandler(e) {
    if (e.key === "ArrowDown" && !menuExpanded) {
      menuButtonRef.current.toggleMenuExpand();
    }
  };

  var handleMenuExpand = function handleMenuExpand(expanded) {
    setMenuExpanded(expanded);
  };

  useEffect(function () {
    if (menuExpanded && rootElementRef.current) {
      var nodeList = rootElementRef.current.querySelectorAll("button[role=menuitem]");
      var linkArray = Array.from(nodeList);
      var searchElement = linkArray.find(function (linkItem) {
        return linkItem.innerHTML.includes(getLanguageName(selectedLocale));
      });

      if (searchElement) {
        var selectedLocaleIndex = linkArray.indexOf(searchElement);
        nodeList.item(selectedLocaleIndex).focus();
      }
    }
  }, [menuExpanded, rootElementRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(supportedLocales.length) && /*#__PURE__*/React.createElement("li", {
    className: getClassName(),
    ref: rootElementRef
  }, /*#__PURE__*/React.createElement(GlobalHeader.BaseItem, {
    label: formatItemLabel(selectedLocale),
    icon: /*#__PURE__*/React.createElement(Globe, {
      label: iconAltText
    }),
    leftSideIcon: true,
    className: getClassName(),
    ref: menuButtonRef,
    onKeyDown: menuButtonKeyDownHandler,
    onMenuExpand: handleMenuExpand
  }, /*#__PURE__*/React.createElement(GlobalHeader.Column, null, /*#__PURE__*/React.createElement(GlobalHeader.NavList, null, supportedLocales.map(function (it) {
    return getListItem(it);
  }))))));
};
LanguageSelector.displayName = "LanguageSelector";